import { defineStore } from 'pinia';
import ContactLabelsAPI from 'dashboard/api/contactLabels';

export const useContactLabelsStore = defineStore('contactLabels', {
  state: () => ({
    labels: [],
    isFetching: false,
    isCreating: false,
    isUpdating: false,
    isDeleting: false,
  }),

  getters: {
    getLabels: state => state.labels,
    getLabelByTitle: state => title =>
      state.labels.find(l => l.title === title),
    getLabelColorMap: state =>
      Object.fromEntries(state.labels.map(l => [l.title, l.color])),
  },

  actions: {
    async fetchAll() {
      // Every contact card calls this on mount; skip while a request is in flight.
      if (this.isFetching) return;
      this.isFetching = true;
      try {
        const { data } = await ContactLabelsAPI.getAll();
        this.labels = data.payload || [];
      } finally {
        this.isFetching = false;
      }
    },

    async create({ title, color = '#6B7280', description = '' }) {
      this.isCreating = true;
      try {
        const { data } = await ContactLabelsAPI.create({
          title,
          color,
          description,
        });
        this.labels.push(data.payload);
        return data.payload;
      } finally {
        this.isCreating = false;
      }
    },

    async update(id, attrs) {
      this.isUpdating = true;
      try {
        const { data } = await ContactLabelsAPI.update(id, attrs);
        const idx = this.labels.findIndex(l => l.id === id);
        if (idx !== -1) this.labels[idx] = data.payload;
        return data.payload;
      } finally {
        this.isUpdating = false;
      }
    },

    async delete(id) {
      this.isDeleting = true;
      try {
        await ContactLabelsAPI.delete(id);
        this.labels = this.labels.filter(l => l.id !== id);
      } finally {
        this.isDeleting = false;
      }
    },

    async getContactLabels(contactId) {
      const { data } = await ContactLabelsAPI.getContactLabels(contactId);
      return data.payload || [];
    },

    async updateContactLabels(contactId, labels) {
      const { data } = await ContactLabelsAPI.updateContactLabels(
        contactId,
        labels
      );
      return data.payload || [];
    },
  },
});
